
import ChatMessage from "@/components/chat/ChatMessage"
import UserAvatar from "@/components/user/UserAvatar"

import { mapActions, mapGetters } from "vuex"
import colors from "@/mixins/colors"

import {
    mdiAccountCancel,
    mdiDelete,
    mdiDeleteForever,
    mdiFaceMan,
} from "@mdi/js"
import dates from "@/mixins/dates"
export default {
    name: "StreamChatMessage",
    components: {
        EditMenu: () => import("@/components/livestream/EditMenu"),
        ChatMessage,
        UserAvatar,
    },
    mixins: [colors, dates],
    props: {
        message: {
            type: Object,
            required: true,
        },
        sameCompanyBefore: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            mdiFaceMan,
            highlightedMessageID: 0,
            editActions: [
                {
                    text: "Delete Message",
                    icon: mdiDelete,
                    id: 1,
                    functionName: "deleteMessage",
                },
                {
                    text: "Block User",
                    icon: mdiAccountCancel,
                    id: 3,
                    functionName: "blockUser",
                },
            ],
            deleteAction: {
                text: "Delete all messages from this user",
                icon: mdiDeleteForever,
                id: 4,
                functionName: "deleteAllMessagesFromUser",
            },
            isHighlighted: false,
        }
    },
    computed: {
        ...mapGetters("livestream", ["getCompanyFromSlug"]),

        isBusinessMessage() {
            return !!this.message.business_name
        },
        avatarColor() {
            return this.stringToRGB(this.message.nickname)
        },
        isAdminMessage() {
            return this.message.business_name === "Oabat"
        },
        userObject() {
            return {
                name: this.message.nickname,
                profile_picture: this.message.user_profile_picture,
            }
        },
        textColor() {
            if (this.isAdminMessage) {
                return "rgba(255, 50, 50)"
            }
            return this.avatarColor
        },
        backgroundColor() {
            if (!this.isBusinessMessage) return ""
            if (this.isAdminMessage) {
                return "linear-gradient(to right, rgba(54, 67, 239,0.5), rgba(255, 110, 145,0.6));"
            }
            const rgb = this.avatarColor
                .substring(4, this.avatarColor.length - 1)
                .replace(/ /g, "")
                .split(",")
            return `rgba(${rgb[0]},${rgb[1]},${rgb[2]},0.1)`
        },
    },
    methods: {
        toggleHighlightMessage() {
            this.isHighlighted = !this.isHighlighted
        },
        callFunction(functionName, data) {
            return this[functionName](data)
        },
        ...mapActions("livestream", [
            "deleteMessage",
            "blockUser",
            "deleteAllMessagesFromUser",
        ]),
    },
}
